var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.11133H5.83333M17.5 5.11133H9.16667M2.5 10.9447H12.5M17.5 10.9447H15.8333M2.5 16.778H4.16667M17.5 16.778H7.5",
    stroke: "#1C66F6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 6.77865C8.42113 6.77865 9.16732 6.03245 9.16732 5.11198C9.16732 4.1915 8.42113 3.44531 7.50065 3.44531C6.58018 3.44531 5.83398 4.1915 5.83398 5.11198C5.83398 6.03245 6.58018 6.77865 7.50065 6.77865Z",
    stroke: "#1C66F6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 12.6126C15.0871 12.6126 15.8333 11.8664 15.8333 10.946C15.8333 10.0255 15.0871 9.2793 14.1667 9.2793C13.2462 9.2793 12.5 10.0255 12.5 10.946C12.5 11.8664 13.2462 12.6126 14.1667 12.6126Z",
    stroke: "#1C66F6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 18.4447C6.75316 18.4447 7.49935 17.6985 7.49935 16.778C7.49935 15.8575 6.75316 15.1113 5.83268 15.1113C4.91221 15.1113 4.16602 15.8575 4.16602 16.778C4.16602 17.6985 4.91221 18.4447 5.83268 18.4447Z",
    stroke: "#1C66F6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4f7b64639fb8bd217a0c8361aae8d058.svg";
export { ForwardRef as ReactComponent };